import * as request from "@/utils/requestTog";

export default {
  /** 获取当前认证状态 */
  getAuthStatus(data) {
    return request.get("/v1/hr/company/auth/status", data);
  },
  /** 实名认证授权 */
  postRealAuth(data) {
    return request.post("/v1/hr/company/real/auth", data);
  },
  /** 获取印章列表 */
  getSealList(data) {
    return request.get("/v1/hr/company/seal/list", data);
  },
  /** 印章授权 */
  postSealAuth(data) {
    return request.post("/v1/hr/company/seal/auth", data);
  },
  /** 认证灵工（风控材料上传） */
  postLgRiskUpload(data) {
    return request.post("/v1/hr/company/lg/risk/upload", data);
  },
  /** 认证灵工（新申请） */
  postLgApply(data) {
    return request.post("/v1/hr/company/lg/apply", data);
  },
  /** 校验验证码是否正确 */
  verifySms(data) {
    return request.post("/v1/sms/verify", data);
  },
  /** 获取开票类目 */
  getInvoiceType(data) {
    return request.get("/v1/hr/company/risk/category/list", data);
  },
  /** 获取风控表签署状态 */
  getQsStatus(id, data) {
    return request.get(`/v1/hr/company/risk/sign/status/${id}`, data);
  },
  getV1OssSign(data) {
    return request.get('/v1/oss/sign', data)
  },
};
